export default __webpack_public_path__ + "454d892d5ea73a64f057500edc6900bf.webp";